import { hasOnlyMenuGrantAccess, type ErpMenu } from "@eurostorm/shared";
import { useAuth } from "./useAuth.js";

/**
 * F-acesso-por-menu (CEO 2026-10-12) — usuário de PORTAL (gerente de
 * chantier) que entra no Gestion só pelos menus liberados em Usuários.
 *
 * `grantOnly` = sem papel de ERP (viewer/user/admin); o servidor já recorta
 * os dados aos chantiers dele e nunca devolve comissão. A tela usa isto para
 * (1) mostrar só os menus liberados, (2) não disparar consultas financeiras
 * que ele não tem (sininho, cards de caixa) e (3) esconder abas de dinheiro
 * do técnico.
 */
export function useGrantOnly(): {
  grantOnly: boolean;
  menus: ErpMenu[];
  canOperate: (menu: ErpMenu, companyId?: number | null) => boolean;
} {
  const { user } = useAuth();
  const grantOnly = user != null && hasOnlyMenuGrantAccess(user);
  const grants = grantOnly ? (user?.menuGrants ?? []) : [];
  const menus = [...new Set(grants.map((g) => g.menu))];
  return {
    grantOnly,
    menus,
    canOperate: (menu, companyId) =>
      !grantOnly ||
      grants.some(
        (g) =>
          g.menu === menu &&
          g.level === "operate" &&
          (companyId == null || g.companyId === companyId),
      ),
  };
}
